const list = [{
		img: require('@/assets/image/index/index-lun-1.png')
	},
	{
		img: require('@/assets/image/index/index-lun-1.png')
	},
	{
		img: require('@/assets/image/index/index-lun-1.png')
	}
]

const store = [{
		toptitle: "门店推荐",
		img: require('@/assets/image/index/1.png'),
		title: "南城家园家园11栋2单元1304号门店",
		addres: "朝阳区",
		size: "118.75平方米",
		price: "3500"
	},
	{
		toptitle: "门店推荐",
		img: require('@/assets/image/index/2.png'),
		title: "南城家园家园11栋2单元1304号门店",
		addres: "朝阳区",
		size: "118.75平方米",
		price: "3500"
	},
	{
		toptitle: "门店推荐",
		img: require('@/assets/image/index/3.png'),
		title: "南城家园家园11栋2单元1304号门店",
		addres: "朝阳区",
		size: "118.75平方米",
		price: "3500"
	}
]

const listData = [{
	'title': '各位漂泊的精英人才们，小寓在长春寻找期待“…',
	'date': '2022-08-04'
}, {
	'title': '各位漂泊的精英人才们，小寓在长春寻找期待“…',
	'date': '2022-08-04'
}, {
	'title': '各位漂泊的精英人才们，小寓在长春寻找期待“…',
	'date': '2022-08-04'
}, {
	'title': '各位漂泊的精英人才们，小寓在长春寻找期待“…',
	'date': '2022-08-04'
}, {
	'title': '各位漂泊的精英人才们，小寓在长春寻找期待“…',
	'date': '2022-08-04'
}, {
	'title': '各位漂泊的精英人才们，小寓在长春寻找期待“…',
	'date': '2022-08-04'
}, {
	'title': '各位漂泊的精英人才们，小寓在长春寻找期待“…',
	'date': '2022-08-04'
}, {
	'title': '各位漂泊的精英人才们，小寓在长春寻找期待“…',
	'date': '2022-08-04'
}, {
	'title': '各位漂泊的精英人才们，小寓在长春寻找期待“…',
	'date': '2022-08-04'
}]

const listthress = [{
		title: "通知公告 ",
		list: [{
				name: "温馨提示：准租证有效期为90天，超期需到…"
			},
			{
				name: "温馨提示：准租证有效期为90天，超期需到…"
			}
		]
	},
	{
		title: "入住须知 ",
		list: [{
				name: "长春市人才公寓入住须知"
			},
			{
				name: "长春市人才公寓管理规定"
			}
		]
	},
	{
		title: "常见问题",
		list: [{
			name: "温馨提示：准租证有效期为90天，超期需到…",
			content: "答：根据《长春市人才公寓租赁管理办法》…"
		}]
	},
]
const survey = [{
		img: require('@/assets/image/index/11.png'),
		name: "智慧租赁社区",
		content: '在线看房、在线签约、在线缴费、在线报修，进一步实现“网络多跑腿，人才少跑腿”；设置独立门禁、智能门锁、智慧监控，使居住更加便捷安全'
	},
	{
		img: require('@/assets/image/index/12.png'),
		name: "智慧租赁社区",
		content: '在线看房、在线签约、在线缴费、在线报修，进一步实现“网络多跑腿，人才少跑腿”；设置独立门禁、智能门锁、智慧监控，使居住更加便捷安全'
	},
	{
		img: require('@/assets/image/index/13.png'),
		name: "智慧租赁社区",
		content: '在线看房、在线签约、在线缴费、在线报修，进一步实现“网络多跑腿，人才少跑腿”；设置独立门禁、智能门锁、智慧监控，使居住更加便捷安全'
	}
]

const imglist = [{
		img: require('@/assets/image/index/4.png'),
	}, {
		img: require('@/assets/image/index/j-1.png'),
	},
	{
		img: require('@/assets/image/index/j-2.png'),
	},
	{
		img: require('@/assets/image/index/j-3.png'),
	},
	{
		img: require('@/assets/image/index/j-4.png'),
	},
	{
		img: require('@/assets/image/index/j-5.png'),
	}
]


export {
	list,
	store,
	listData,
	listthress,
	survey,
	imglist
}
